var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.search},[_c('Title',{staticStyle:{"padding":"0 0.5em"},attrs:{"bold":"","strong":""}},[_vm._v(" 查詢捐款記錄 ")]),_c('RouterView')],1)}
var staticRenderFns = []

export { render, staticRenderFns }